<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <form
      ref="form"
      data-url="complaints/areaDirectorComplaintDocuments/store705"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row" v-if="inputs.observation">
        <label class="col-12">
          Observación
          <app-input
            type="textarea"
            v-model="inputs.observation"
            :disabled="true"
          />
        </label>
      </div>

      <div class="row">
        <div
          class="col-md-12"
          v-if="
            inputs.area_director_complaint_historical &&
            inputs.area_director_complaint_historical.length > 0
          "
        >
          <legend class="text-primary mb-4 mt-3">
            <h5>Historial de informes del director de area</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in inputs.area_director_complaint_historical"
                :key="key"
              >
                <td class="align-middle">
                  {{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(inputs.area_director_complaint_historical, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <label class="col-12 mt-3">
          Informe del director de area (Queja)
          <span class="color_import">*</span>
        </label>
        <app-input
          type="file"
          class="col-sm-6"
          :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
          v-model="inputs.file_1"
          :required="true"
          v-if="!inputs.area_director_complaint_document"
        />
      </div>
      <div class="mt-2">
        <button
          type="submit"
          class="btn btn-success"
          @click.prevent="openTab(inputs, 'area_director_complaint_document')"
          v-if="inputs.area_director_complaint_document"
        >
          <app-icon name="file" />
          {{ $t("view") }}
        </button>

        <button
          type="submit"
          class="btn btn-danger"
          @click.prevent="openDeleteModal('area_director_complaint_document')"
          v-if="inputs.area_director_complaint_document"
        >
          <app-icon name="trash-2" />
          {{ $t("delete") }}
        </button>
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />
    </form>
  </div>
</template>

<script>
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  name: "ComplaintAreaComplaintDocument",
  mixins: [FormMixin],
  props: {
    id: String,
    dgc_complaint_document: Object,
    area_director_complaint_document: Object,
    analysis_complaint_document: Object,
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      selected: "",
      inputs: {},
    };
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  created() {
    this.loadForm();
    this.getData();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.preloader = false;
      this.inputs = res.data.data;
      this.$toastr.s(this.$t("complaint_success"));
    },
    getData() {
      let url = `complaints/areaDirectorComplaintDocuments/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
    },
    cancelled() {
      this.deleteModal = false;
    },
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          dgc_complaint_document:
            this.$store.state.evaluatorReview.evalTest.dgc_complaint_document,
          area_director_complaint_document:
            this.$store.state.evaluatorReview.evalTest
              .area_director_complaint_document,
          analysis_complaint_document:
            this.$store.state.evaluatorReview.evalTest
              .analysis_complaint_document,
        };
      }
    },
  },
};
</script>

<style>
.color_import {
  color: #ff5733;
}
</style>
